<template>
	<div class="card flex justify-center">
		<Galleria v-model:activeIndex="activeIndex" v-model:visible="displayCustom" :value="images" :responsiveOptions="responsiveOptions" :numVisible="7" containerStyle="max-width: 850px" :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false">
			<!-- item utama -->
			<template #item="slotProps">
				<img v-if="['png','jpeg', 'jpg'].includes(slotProps.item.extFile)" :src="slotProps.item.previewUrl" :alt="slotProps.item.file_name" style="width: 100%; display: block" />
				<iframe v-else-if="['pdf'].includes(slotProps.item.extFile)" :src="slotProps.item.previewUrl" style="height: 600px; width: 100%; display: block" frameborder="0"></iframe>
				<iframe
					v-else-if="['doc','docx','xls','xlsx','ppt','pptx'].includes(slotProps.item.extFile)"
					:src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(slotProps.item.previewUrl)}`"
				style="height: 600px; width: 100%; display: block;"
					frameborder="0"
				></iframe>
				<div v-else>
					File type {{ slotProps.item.file_name }} not supported.
				</div>
			</template>
		</Galleria>
	</div>
</template>

<script>
import baseApiUrl from "@/configs/config";

export default {
	props: {
    rawFiles: {
      type: Array,
      required: true
    },
		openIndex: { 
			type: Number,
			default: 0,
			required: true
		},
		openToDisplay: {
			type: Boolean,
			default: false,
			required: true
		}
  },
	data() {
		return {
			activeIndex: 0,
			displayCustom: false,
			images: [],
			responsiveOptions: [
				{ breakpoint: '1024px', numVisible: 5 },
				{ breakpoint: '768px', numVisible: 3 },
				{ breakpoint: '560px', numVisible: 1 }
			],
			apiUrl: baseApiUrl.apiUrl,
		};
	},
	watch: {
		openToDisplay(val) {
			if (val) {
				this.activeIndex = this.openIndex;
				this.displayCustom = true;
				this.loadImages();
			}
		},
		displayCustom(val) {
			if (!val) this.$emit('close');
			else {
				const checkButton = setInterval(() => {
					const closeBtn = document.querySelector('.p-galleria-close-button');
					const imgElement = document.querySelector('.p-galleria-item img');
					if (closeBtn && imgElement) {
						const imgRect = imgElement.getBoundingClientRect();
						const topPosition = imgRect.bottom + 20;
						closeBtn.style.cssText = `position: fixed !important; top: ${topPosition}px !important; right: auto !important; bottom: auto !important; left: 50% !important; transform: translateX(-50%) !important; z-index: 9999 !important;`;
						clearInterval(checkButton);
					}
				}, 50);
				
				setTimeout(() => clearInterval(checkButton), 2000);
			}
		}
	},
	beforeUnmount() {
		this.images.forEach((img) => {
			if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
		});
	},
	methods: {
		async loadImages() {
			const token = localStorage.getItem("token");
			this.images = await Promise.all(
				this.rawFiles.map(async (item) => {				
					const extension = item.file_name.split('.').pop().toLowerCase();
					try {
						const response = await fetch(`${this.apiUrl}/dictionary/smartcat-attachment/file/${item.id}`, {
							method: "GET",
							headers: { Authorization: `Bearer ${token}` },
						});
						const blob = await response.blob();
						const url = URL.createObjectURL(blob);

						return {...item, extFile: extension, previewUrl: url};
					} catch (err) {
						this.$toastNotifPrime("error", "Get Image Failed", `Error load ${item.file_name}`);
						return {...item, extFile: extension, previewUrl: "" };
					}
				})
			);
		},
	},
};
</script>

<style>
::v-deep(.p-galleria-close-button) {
  position: fixed !important;
  top: auto !important;
  right: auto !important;
  bottom: 2rem !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}
</style>
